import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ReviewReleasemail } from "@tSchaedlerYesco/Services/ReleaseOrderService";

interface OrderReleaseProduct {
    ProductERPNumber: string;
    ReleasedQuantity: number;
    ProductMFGNumber: string;
    ProductDescriptionName: string;
}

type SubmitContactFormParameter = {
    WebOrderNumber: string;
    ERPOrderNumber: string;
    ReleaseId: string;
    SalesWriterId: string;
    ReleaseDate: string;
    ReleaseNotes: string;
    ReleaseProductsList: OrderReleaseProduct[];
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, SubmitContactFormParameter>;

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState().components.contactUsForm;

    props.apiParameter = {
        WebOrderNumber: props.parameter.WebOrderNumber,
        ERPOrderNumber: props.parameter.ERPOrderNumber,
        ReleaseId: props.parameter.ReleaseId,
        SalesWriterId: props.parameter.SalesWriterId,
        ReleaseNotes: props.parameter.ReleaseNotes,
        ReleaseDate: props.parameter.ReleaseDate,
        ReleaseProductsList: props.parameter.ReleaseProductsList,
    };
};

export const SendDataToApi: HandlerType = async props => {
    await ReviewReleasemail(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitReviewReleaseForm = createHandlerChainRunner(chain, "submitReviewReleaseForm");
export default submitReviewReleaseForm;
